/*
 * Email signup interactions — scoped per [data-email-signup] root.
 * Hooks: [data-email-signup-button], [data-email-signup-input] inside the form.
 */

class EmailSignup {
  constructor(root) {
    this.root = root;
    this.input = root.querySelector('input[data-email-signup-input], input[type="email"]');
    this.button = root.querySelector('[data-email-signup-button]');

    if (!this.input || !this.button) return;

    this.init();
  }

  init() {
    this.bindEvents();
    this.validate(); // Initial check in case of browser autocomplete or pre-filled values
  }

  validate() {
    const isValid = this.input.checkValidity();
    this.setButtonState(this.button, !isValid);
  }

  setButtonState(btn, isDisabled) {
    if (!btn) return;
    btn.disabled = isDisabled;
  }

  bindEvents() {
    ['input', 'change'].forEach((event) => {
      this.input.addEventListener(event, () => {
        // Clear any previous customError so checkValidity reflects current state
        this.input.setCustomValidity('');
        this.validate();
      });
    });

    // Override the generic 'patternMismatch' message with the email-specific one;
    // form-validation.js respects customError before patternMismatch in messageFor().
    // TODO(i18n): localize the fallback message when translation keys are introduced.
    this.input.addEventListener('invalid', () => {
      this.input.setCustomValidity(
        this.input.validity.patternMismatch ? 'Email not valid.' : '',
      );
    });
  }
}

function initSections(container = document) {
  const selector = '[data-email-signup]:not([data-email-signup-init])';
  const roots = container.matches?.(selector) ? [container] : container.querySelectorAll(selector);

  roots.forEach((root) => {
    root.dataset.emailSignupInit = 'true';
    new EmailSignup(root);
  });
}

initSections();

document.addEventListener('shopify:section:load', (e) => initSections(e.target));
